import VueRouter from 'vue-router';

const brandsList = 'abarth|alfa-romeo|audi|bmw|citroen|cupra|dacia|ds|fiat|ford|honda|hyundai|jaguar|jeep|kgm|kia|land-rover|leapmotor|lexus|maxus|mazda|mercedes-benz|mg|mini|mitsubishi|nissan|peugeot|renault|seat|skoda|smart|suzuki|toyota|vauxhall|volkswagen|volvo';

let routes = [
    {
        path: '/used-vehicles',
        name: 'used-landing',
        component: () => import('./views/used-landing.vue'),
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
                'bg-peugeot'
            ],
            title: "Used Cars for Sale | Used SUVs, Hatchbacks, Saloons",
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: "Explore approved used cars near you at Stellantis &You. Browse used SUVs, hatchbacks and saloons. Find great deals on second hand cars and book a test drive.",
            customerType: 'Used',
        }
    },
    {
        path: '/new-cars-in-stock',
        name: 'new-cars-in-stock',
        component: () => import('./views/stock-search/stock-search-landing.vue'),
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
                'stock-search-landing',
            ],
            title: 'New Peugeot, Citroen, DS and Vauxhall Cars and Vans for Sale in UK. Finance available',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Explore the latest new  cars for sale at Stellantis &You UK and discover a wide array of Peugeot, Citroen, DS and Vauxhall cars and vans.',
            newStockSearch: true,
            customerType: 'New',
        }
    },
    {
        path: `/:brand(${brandsList})/used-vehicles`,
        name: 'branded-used-landing',
        component: () => import('./views/used-landing.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
                'landing',
                'bg-peugeot'
            ],
            manufacturer: 'Peugeot',
            brand: 'randd',
            title: 'Used Cars For Sale | Approved Nearly New & Second Hand Cars Near me',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        },
    },
    {
        path: `/:brand(${brandsList})/new-cars-in-stock`,
        name: 'branded-new-cars-in-stock',
        component: () => import('./views/stock-search/stock-search-landing.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
                'landing',
                'bg-peugeot',
                'stock-search-landing',
            ],
            manufacturer: 'Peugeot',
            brand: 'randd',
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            newStockSearch: true,
            customerType: 'New',
        },
    },
    {
        path: '/:resultsType(used-vehicles|nearly-new|used-special-offers|delivery-mileage)/results',
        name: 'used-results',
        component: () => import('./views/used-results.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            title: 'Stellantis &You UK | Used Vehicle Results',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/new-cars-in-stock/results',
        name: 'stock-search-results',
        component: () => import('./views/stock-search/stock-search-results.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
                'stock-search-results',
            ],
            searchPage: true,
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            title: 'Stellantis &You UK | Brand New Vehicles In Stock',
            desc: 'Find brand new vehicles in stock near you with Stellantis &You UK - Get great deals on new cars, book a test drive & discuss our amazing finance deals',
            newStockSearch: true,
            customerType: 'New',
        }
    },
    {
        path: `/:brand(${brandsList})/:resultsType(used-vehicles|nearly-new|used-special-offers|delivery-mileage)/results`,
        name: 'branded-used-results',
        component: () => import('./views/used-results.vue'),
        props: true,
        meta: {
            // brand: 'peugeot',
            bodyClasses: [
                'used',
                'search',
            ],
            manufacturer: 'Stellantis &You UK',
            searchPage: true,
            title: 'Stellantis &You UK | Used Vehicle Results',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: `/:brand(${brandsList})/new-cars-in-stock/results`,
        name: 'branded-stock-search-results',
        component: () => import('./views/stock-search/stock-search-results.vue'),
        props: true,
        meta: {
            // brand: 'peugeot',
            bodyClasses: [
                'used',
                'stock-search-results',
            ],
            manufacturer: 'Stellantis &You UK',
            searchPage: true,
            title: 'Stellantis &You UK | Brand New Vehicles In Stock',
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            newStockSearch: true,
            customerType: 'New',
        }
    },
    {
        path: '/used-vehicles/dealer/:slug',
        name: 'dealer-landing-page',
        component: () => import('./views/used-results.vue'),
        meta: {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            // title: 'Stellantis &You UK | Used Vehicle Results',
            skipMediahawk: true,
            alwaysVerifyRoute: true,
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: `/:brand(${brandsList})/used-vehicles/:slug`,
        name: 'branded-cms-landing-page',
        component: () => import('./views/used-results.vue'),
        meta: {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            // title: 'Stellantis &You UK | Used Vehicle Results',
            skipMediahawk: true,
            alwaysVerifyRoute: true,
            showMultiBrandLiveChat: true,
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/free-credit-check',
        name: 'general-credit-check',
        component: () => import('./views/finance/general-credit-check.vue'),
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Free credit check | Stellantis &You UK',
            desc: 'Check your likelihood of being accepted for credit with our free online credit check',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/:applicationType(soft|full)/:id',
        name: 'build-quote',
        component: () => import('./views/finance/build-quote.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Apply for finance | Stellantis &You UK',
            desc: 'Apply online for finance on our used cars',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/:applicationType(soft|full)/:id/:quoteRef',
        name: 'finance-application',
        component: () => import('./views/finance/finance-application.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Apply for finance | Stellantis &You UK',
            desc: 'Apply online for finance on our used cars',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/credit-score/:reference',
        name: 'credit-score',
        component: () => import('./views/finance/credit-score.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Your credit score | Stellantis &You UK',
            desc: 'Apply online for finance on our used cars',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/status/:reference',
        name: 'finance-application-status',
        component: () => import('./views/finance/finance-status.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Finance application status | Stellantis &You UK',
            desc: 'Apply online for finance on our used cars',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/finance/reserve/:reference',
        name: 'finance-reservation',
        component: () => import('./views/finance/reserve-application.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used',
            ],
            searchPage: false,
            showMultiBrandLiveChat: true,
            skipMediahawk: true,
            title: 'Reserve your vehicle | Stellantis &You UK',
            desc: 'Apply online for finance on our used cars and reserve online',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/purchase/outcome/:reference',
        name: 'buy-online-payment-outcome',
        component: () => import('./views/buy-online/payment-outcome.vue'),
        props: true,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
            ],
            title: "Buy Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/purchase/:id',
        name: 'buy-online-landing',
        component: () => import('./views/buy-online/landing.vue'),
        props: true,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
            ],
            title: "Buy Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/saved-vehicles/:type(new|used|motability)',
        name: 'saved-vehicles',
        component: () => import('./views/saved-vehicles.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'saved-vehicles',
                'used',
            ],
            showMultiBrandLiveChat: true,
            title: 'Saved Vehicles | Stellantis &You UK',
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/reserve/resume',
        name: 'reserve-online-resume',
        component: () => import('./views/reserve-online/landing-page.vue'),
        props: false,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
            ],
            title: "Reserve Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/reserve/status',
        name: 'reservation-status',
        component: () => import('./views/reserve-online/status.vue'),
        props: true,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
            ],
            title: "Reserve Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/reserve/finance-status',
        name: 'reservation-finance-status',
        component: () => import('./views/reserve-online/finance-status.vue'),
        props: true,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
            ],
            title: "Reserve Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/reserve/:id',
        name: 'reserve-online-landing',
        component: () => import('./views/reserve-online/landing-page.vue'),
        props: true,
        meta: {
            brand: 'randd',
            bodyClasses: [
                'used',
                'landing',
            ],
            title: "Reserve Online | Stellantis &You UK",
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/stock-alert',
        name: 'car-alert',
        component: () => import('./views/car-alert/index.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'car-alert',
                'used',
            ],
            showMultiBrandLiveChat: true,
            title: 'Stock Alert | Stellantis &You UK',
            desc: 'Get notified when approved used cars near you come in stock with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/:slug',
        name: 'cms-landing-page',
        component: () => import('./views/used-results.vue'),
        meta: {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            // title: 'Stellantis &You UK | Used Vehicle Results',
            skipMediahawk: true,
            alwaysVerifyRoute: true,
            showMultiBrandLiveChat: true,
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        }
    },
    {
        path: '/used-vehicles/:id/:slug',
        name: 'used-details',
        component: () => import('./views/used-details.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used-details',
            ],
            title: 'Stellantis &You UK | Used Vehicle Details',
            skipMediahawk: true,
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            desc: 'Find approved used cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
            customerType: 'Used',
        },
    },
    {
        path: '/new-cars-in-stock/:id/:slug',
        name: 'new-cars-in-stock-details',
        component: () => import('./views/stock-search/stock-search-details.vue'),
        props: true,
        meta: {
            bodyClasses: [
                'used-details',
            ],
            title: 'Stellantis &You UK | New Vehicle In Stock Details',
            skipMediahawk: true,
            title: 'New Cars for Sale | Review & Buy Brand New Car Models in Our 2021 Range',
            desc: 'Explore the latest new cars for sale at Stellantis &You UK and discover a wide array of models in our 2021 range - Discuss finance and book a test drive',
            customerType: 'New',
        }
    },
];

let scrollBehavior = function(to, from, savedPosition) {
    if (to.hash) {
        return {
            selector: to.hash
            , offset: {x:0, y:105}
        };
    }
    return { selector: 'body', offset: {x:0, y:105} };
};

export default new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior,
    base: '/',
    linkActiveClass: 'active',
});